var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.563 8.024L15 3.174l11.438 4.85c.368.156.568.488.562.8-.025 5.713-2.4 15.581-11.644 20.006a.822.822 0 01-.706 0C5.4 24.4 3.031 14.537 3 8.818c0-.313.194-.638.563-.8v.006zm24.043-2.762L15.837.268a2.018 2.018 0 00-1.675 0L2.394 5.262C1.019 5.842-.006 7.199 0 8.837c.031 6.2 2.581 17.543 13.35 22.7 1.044.5 2.256.5 3.3 0 10.775-5.157 13.319-16.5 13.35-22.7.006-1.638-1.019-2.994-2.394-3.575zM15 8.087c-.831 0-1.5.668-1.5 1.5v7c0 .83.669 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.832-.669-1.5-1.5-1.5zm2 14a2 2 0 10-4 0 2 2 0 004 0z",
    fill: "#FF9C00"
  })));
}
export default SvgShieldExclamation;